import { InputBase, Box, FormControl, styled, InputAdornment } from '@mui/material';
import { rem } from '@core-web/typography';

export interface IStyledInputProp {
  variants?: string[];
}

export const StyledFormControl = styled(FormControl)(({ theme: {} }) => ({
  width: '100%',
  rowGap: rem(6),
  // height: rem(64),
  outline: 'none',
}));

export const StyledInput = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== 'variants',
})<IStyledInputProp>(({ theme: { spacing, palette, typography, shape }, variants }) => ({
  width: '100%',
  height: rem(48),
  border: '1px solid',
  borderColor: `${palette.border.main}`,
  borderRadius: shape.borderRadius,
  padding: spacing(1.5, 2),
  fontSize: typography.subtitle2.fontSize,
  backgroundColor: variants?.length && variants?.length > 1 ? variants[1] : palette.colors.white,
  '&:hover': {
    borderColor: palette.border.dark,
  },
  '&.withRequiredBorder': {
    borderColor: `${palette.colors.orange}`,
  },
  '&.hasValue': {
    borderColor: `${variants?.length ? variants[0] : palette.colors.grey_300}`,
  },
  '&.withValue': {
    svg: {
      fill: palette.colors.grey_500,
    },
  },
  '&.Mui-focused': {
    borderColor: palette.colors.grey_300,
    '&:hover': {
      borderColor: palette.colors.grey_300,
    },
    svg: {
      fill: palette.colors.orange,
    },
    ' .MuiInputAdornment-positionEnd': {
      button: {
        svg: {
          fill: palette.colors.orange,
        },
      },
    },
  },
  '&.Mui-readOnly': {
    borderColor: variants?.length ? variants[0] : palette.colors.grey_200,
    '&:hover': {
      borderColor: variants?.length ? variants[0] : palette.colors.grey_200,
    },
  },
  '&.Mui-error': {
    borderColor: `${palette.error.main}`,
    backgroundColor: `${palette.error.bgLight}`,
    '&:hover': {
      borderColor: `${palette.error.dark}`,
    },
    input: {
      color: palette.error.main,
    },
  },
  '&.Mui-disabled': {
    display: 'flex',
    alignItems: 'center',

    backgroundColor: palette.background.disabled,
    color: palette.colors.grey_300,

    '&:hover': {
      borderColor: palette.border.main,
    },
  },
  input: {
    color: palette.colors.grey_900,
    fontSize: rem(14),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: rem(20),
    '&[readonly]': {
      color: palette.colors.grey_300,
    },
  },
  ' .MuiInputAdornment-positionEnd': {
    button: {
      svg: {
        fill: palette.colors.grey_500,
      },
    },
  },
}));

export const AdornmentWrapper = styled(InputAdornment)(({ theme: { spacing } }) => ({
  paddingRight: spacing(1),
  display: 'flex',
  alignItems: 'center',
  svg: {
    fill: 'black',
  },
  position: 'relative',
  top: rem(4),
}));

export const ErrorWrapper = styled(Box)(({ theme: {} }) => ({
  textAlign: 'left',
}));

export const InputWrapper = styled(Box)(({ theme: {} }) => ({
  position: 'relative',
}));
